

















































































import { Choice } from '@/api/model/Choice';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import _ from 'lodash';

@Component({
    components: { CardTitle },
})

export default class CopyResourcesDialog extends Vue {

    // mdi-file-outline
    @Prop({ default: 'mdi-file-outline', type: String })
    iconName!: string;

    @Prop({ default: '', type: String })
    btnText!: string;

    @Prop({ default: '', type: String })
    btnClass!: string;

    @Prop({ default: true, type: Boolean })
    icon!: boolean;

    @Prop({ default: true, type: Boolean })
    small!: boolean;

    @Prop({ default: '', type: String })
    resourceName!: string;

    @Prop({default: ()=>([]), type: Array})
    resourcesFromParent!: any[]

    @Prop({default: false, type: Boolean})
    listActivator!: boolean

    @Prop({default: false, type: Boolean})
    skipActivator!: boolean

    @Prop({default: false, type: Boolean})
    open!: boolean

    private resourceMap = {}
    private dialog = false;
    private save = false;
    private clear = false;
    private loading = false;
    private show = false;


    @Watch('dialog')
    private onChangeResourceMap() {
        if(this.dialog) {
            this.resourceMap = {};
            this.resourcesFromParent.map((resource:any) => Vue.set(this.resourceMap, resource.id ? resource.id: resource.viewpointId , ''));
        }
          
    }

    

    private copyResources() {
        this.$emit('copy', this.resourceMap);
        this.dialog = false;
    }
}
